import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import CONSTANT, { CACHE } from '../../utils/constants';
import { staticPath, getKey } from '../../utils/common';
import BankAccountDetails from './bank-account-details';
import BankListsWrapper from '../nb/BankListsWrapper';
import BankDetailsConfirm from './bank-details-confirm';
import {
  setOptedBankData,
  changeBank,
  setAccountDetails,
  displayConfirmationScreen,
  closeSubsConfirmScreen,
  isBankDetailsEditable,
  onConfirmSubmit,
  formatData,
  filterBanks,
  filterByAlphabet
} from '../../controllers/bank-mandate';
import { locale } from '../../utils/i18n';
import { onChange } from '../../common/actions';
import { EVENT, log } from '../../common/logger';
import OverlayWrap from '../OverlayWrap';
import { postInWindow } from '../../utils/formPost';

class BankMandate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBanksScreen: true,
      showOtherBanks: false,
      showAccountDetailsScreen: false,
      showConfirmationScreen: false,
      isSearchFocused: false,
      bankListsData: props.option.payChannelOptions || {},
      filterBankData: {},
      showFilteredData: false
    };
    this.optedBankData = {};
    this.isSearchFocusedLogged = false;
    this.authenticateModes = [];
    this.popularBanks = this.getPopularBanks(this.state.bankListsData);
    this.accountDetails = setAccountDetails(props.mandateAccountDetails);
    this.populateBank();
    this.bankDetailsEditable = isBankDetailsEditable(props.mandateAccountDetails);
  }

  closeOtherBankList = () => {
    this.setState({ showOtherBanks: false });
  };

  populateBank = () => {
    const { channelName, channelCode, iconUrl, mandateAuthMode } = this.accountDetails;
    channelCode &&
      this.setSelectedBank({
        channelName,
        channelCode,
        iconUrl,
        mandateAuthMode
      });
  };

  getPopularBanks = banks => {
    banks = banks || [];
    return banks.slice(0, 5);
  };

  onOptionSelect = option => {
    this.props.onOptionSelect(option);
    this.props.onBtnTextChange('Proceed');
    this.props.onPayChange(true);
  };

  submit = () => {
    this.child._component.onProceed();
  };

  onProceedSubmit = (accountNumber, accountHolderName, ifsc, mandateAuthMode) => {
    this.accountDetails = setAccountDetails({
      accountNumber,
      accountHolderName,
      ifsc,
      mandateAuthMode
    });
    const stateData = displayConfirmationScreen();
    this.setState(stateData);
  };

  selectOtherBankList = () => {
    this.setState({ showOtherBanks: true });
    log({ eventType: EVENT.BM_SELECT_OTHER_BANKS_CLICK, payMode: CONSTANT.BM });
    this.props.cache.getData(CACHE.STORE).setState({ stopScroll: true });
  };

  setSelectedBank = data => {
    this.optedBankData = data;
    this.cancel();
    this.authenticateModes = data.mandateAuthMode;
    const stateData = setOptedBankData(data);
    this.setState(stateData);
    this.clearSeacrh();
  };

  changeSlectedBank = () => {
    const stateData = changeBank();
    this.setState(stateData);
  };

  accountDetails = data => {
    this.accountDetails = setAccountDetails(data);
  };

  closeConfirmScreen = () => {
    this.setState(closeSubsConfirmScreen());
  };

  onConfirm = () => {
    this.setState({ genericError: '', btnDisabled: false });
    this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANT.PROCESSING });
    log({ eventType: EVENT.BUTTON_CLICK, payMode: CONSTANT.BM });
    onConfirmSubmit(this.accountDetails, this.optedBankData, false, this.props.cache)
      .then(response => {
        const notifyMerchant = getKey(
          this.props.cache.getData(CACHE.MERCHANT_CONFIG),
          'handler.notifyMerchant',
          {}
        );
        if (getKey(response, 'body.resultInfo.resultStatus', undefined) === 'S') {
          const { actionUrl, content } = getKey(response, 'body.bankForm.redirectForm', undefined);
          response.body.content = content;
          response.body.callbackUrl = actionUrl;
          this.setState({ genericError: '', btnDisabled: false });
        } else {
          this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
          const errorMsg = getKey(response, 'body.resultInfo.resultMsg', CONSTANT.GENERIC_ERROR);
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, response);
          }
          this.setState({ genericError: errorMsg, btnDisabled: true });
        }
        postInWindow(response, this.props.cache);
      })
      .catch(res => {
        this.setState(res);
        const notifyMerchant = getKey(
          this.props.cache.getData(CACHE.MERCHANT_CONFIG),
          'handler.notifyMerchant',
          {}
        );
        this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
        if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
          notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, CONSTANT.GENERIC_ERROR);
        }
        postInWindow({}, this.props.cache); // close window in case of network error
      });
  };

  clearSeacrh = () => {
    this.setState({ filterBankData: [], showFilteredData: false, isSearchFocused: false });
  };

  focusIn = () => {
    if (!this.isSearchFocusedLogged) {
      this.isSearchFocusedLogged = true;
    }
    this.setState({ isSearchFocused: true });
  };

  cancel = () => {
    if (document.getElementById('searchBar')) {
      document.getElementById('searchBar').value = '';
      document.getElementById('searchBar').blur();
    }
    this.setState(() => ({
      showOtherBanks: false,
      filterBankData: {},
      showFilteredData: false,
      isSearchFocused: false
    }));
    this.props.onStopScroll(false);
  };

  filterBanks = e => {
    if (e.currentTarget.value) {
      this.setState(prevState => ({
        filterBankData: filterBanks(e.currentTarget.value, prevState.bankListsData),
        showFilteredData: true
      }));
    } else {
      this.setState(prevState => ({
        filterBankData: {},
        bankListsData: prevState.bankListsData,
        showFilteredData: false
      }));
    }
  };

  alphabetFilter = alphabet => {
    this.setState(prevState => ({
      filterBankData: filterByAlphabet(alphabet, prevState.bankListsData),
      showFilteredData: true
    }));
  };

  render(
    { option, isActive, instanceKey },
    {
      showBanksScreen,
      showFilteredData,
      isSearchFocused,
      filterBankData,
      bankListsData,
      showOtherBanks,
      showAccountDetailsScreen,
      showConfirmationScreen,
      btnDisabled,
      genericError
    }
  ) {
    return (
      <section className="ptm-bm-main-wrap">
        <div className="ptm-pay-method ptm-w100-ib" id="checkout-bm">
          <div className="ptm-radio-wrap ptm-pt11">
            <label className="ptm-lbl">
              <input
                type="radio"
                name={`verify${instanceKey}`}
                className="ptm-margin0"
                checked={isActive}
                onClick={() => {
                  this.onOptionSelect(option);
                }}
              />
              <span class="ptm-checkmark" />
              <div class={`ptm-pay-method-cont`}>
                <p class={`ptm-paymode-name `}>{option.displayName}</p>
              </div>
            </label>
          </div>
          {option && isActive && showBanksScreen && (
            <div className={`ptm-nb-inner ptm-pl-35`}>
              <div className={`ptm-nb-list ptm-w100-ib`}>
                {this.popularBanks.map(bank => {
                  return (
                    <div>
                      <div
                        className={`ptm-nb-list-item paytm-txt-center`}
                        onClick={() => this.setSelectedBank(bank)}
                      >
                        <div className={`ptm-pos-r ptm-nb-img ptm-bm-bank-border`}>
                          <img className={`ptm-pos-a`} src={bank.iconUrl} alt="" />
                        </div>
                        <div className={`ptm-bank-name ptm-body-color`}>{bank.channelCode}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {bankListsData && bankListsData.length && bankListsData.length > 5 && (
                <div className={`ptm-bm-select ptm-body-color`} onClick={this.selectOtherBankList}>
                  {locale('bm.select.other.bank')}
                  <img
                    className="ptm-right ptm-margin0"
                    src={`${staticPath()}/assets/images/ic-dropdown-light.svg`}
                    alt=""
                  />
                </div>
              )}
            </div>
          )}
          {option && isActive && showAccountDetailsScreen && (
            <BankAccountDetails
              ref={k => (this.child = k)}
              onProceedSubmit={this.onProceedSubmit}
              bank={this.optedBankData}
              changeBank={this.changeSlectedBank}
              authenticateModes={this.authenticateModes}
              buttonData={this.buttonData}
              accountDetails={this.accountDetails}
              bankDetailsEditable={this.bankDetailsEditable}
            />
          )}
        </div>
        {showOtherBanks && (
          <BankListsWrapper
            bankListsData={formatData(bankListsData)}
            filterBankData={filterBankData}
            cancel={this.cancel}
            filterBanks={this.filterBanks}
            BankOptionClick={this.setSelectedBank}
            showFilteredData={showFilteredData}
            alphabetFilter={this.alphabetFilter}
            isSearchFocused={isSearchFocused}
            focusIn={this.focusIn}
            clearSeacrh={this.clearSeacrh}
          />
        )}
        {showConfirmationScreen && (
          <div className="ptm-emi-ovelay">
            <OverlayWrap>
              <BankDetailsConfirm
                optedBankData={this.optedBankData}
                accountDetails={this.accountDetails}
                {...{ btnDisabled, genericError }}
                onConfirm={this.onConfirm}
                closeConfirmScreen={this.closeConfirmScreen}
              />
            </OverlayWrap>
          </div>
        )}
        <p className={`ptm-global-bottom-border`} />
      </section>
    );
  }
}

export default connect(
  'cache, instanceKey',
  onChange
)(BankMandate);



// WEBPACK FOOTER //
// ./components/bank-mandate/index.js